// import React from 'react';
// import collab from '../Image/collab.svg';
// import Ecell from '../Image/Ecell.webp';
// import webd from '../Image/webd.webp';
// import NIMBUS from '../Image/NIMBUS.webp';
// import vnit from '../Image/vnit.webp';
// import SN from '../Image/SN.webp';
// import Techclub from '../Image/Techclub.webp'
// import Cyfle from '../Image/Cyfle.webp'
// import {
//   MDBCol,
//   MDBRow
// } from "mdb-react-ui-kit";

// const collaborations = [
//   { src: Ecell, alt: "E-cell IIT Hyderabad Logo", title: "E-cell IIT Hyderabad Logo" },
//   { src: vnit, alt: "VNIT", title: "VNIT" },
//   { src: webd, alt: "Webd Logo - Collaboration of InternsElite", title: "Webd Logo - Collaboration of InternsElite" },
//   { src: NIMBUS, alt: "NIMBUS NIT Hamirpur Logo", title: "NIMBUS NIT Hamirpur Logo" },
//   { src: SN, alt: "Snosft_tech", title: "Snosft_tech" },
//   { src: Techclub, alt: "NIT Srinagar", title: "NIT Srinagar" },
//   { src: Cyfle, alt: "Deshbandhu College", title: "Deshbandhu College" },
// ];

// const collaborations1 = [
//   { src: collab, alt: "Our Company Collabration", title: "Our Company Collabration" },
// ];

// function Collabration() {
//   return (
//     <div>
// {/* -------------------------------Mobile View-------------------------------- */}        
//       <div className="pt-5 d-md-none d-sm-block">
//         <div className="container">
//           <div className="text-center px-2 mobile_collabration_img">
//             <h2>Drive Career and Business Success with Strong Collaborations</h2>
//             <p className="pt-2">
//               At InternsElite, we believe in the power of collaboration. Our partnerships with leading industry experts foster innovation, create valuable career opportunities, and support long-term growth. By working together, we deliver impactful results and open new doors for students and professionals. Join us to experience synergy in action and build a path to collective success.
//             </p>
//           </div>
//           <div className="container mt-3">
//             <div className="row mobile_collabration_img">
//               {collaborations.map((collab, index) => (
//                 <div className='col-12 text-center' key={index}>
//                   <img
//                     className='my-2'
//                     src={collab.src}
//                     alt={collab.alt}
//                     title={collab.title}
//                     onContextMenu={(e) => e.preventDefault()}
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
// {/* -------------------------------Desktop View-------------------------------- */}
//       <div className="pt-5 d-md-block d-none">
//         <div className="container">
//           <MDBRow className="d-flex justify-content-center">
//           <MDBCol md="10" className="px-5 text-center pt-2 collabration_img">
//               <h2 className="display-5">Drive Career and Business Success with Strong Collaborations</h2>
//               <p className="mt-3"> At InternsElite, we believe in the power of collaboration. Our partnerships with leading industry experts foster innovation, create valuable career opportunities, and support long-term growth. By working together, we deliver impactful results and open new doors for students and professionals. Join us to experience synergy in action and build a path to collective success.</p>
//           </MDBCol>
//           </MDBRow>
//         </div>
//         <div className="container d-flex justify-content-center mt-3">
//             <div className="collabration_img">
//             {collaborations1.map((collab, index) => (
//                 <div key={index}>
//                   <img
//                     className='my-2'
//                     src={collab.src}
//                     alt={collab.alt}
//                     title={collab.title}
//                     onContextMenu={(e) => e.preventDefault()}
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>
//       </div>
//     </div>
//   );
// }

// export default Collabration;



import React from "react";
import Zoom from "react-reveal/Zoom";
import styled, { keyframes, css } from "styled-components";

import webd from "../Image/webd.webp";
import NIMBUS from "../Image/NIMBUS.webp";
import DU from "../Image/DU.jpg";
import vnit from "../Image/vnit.webp";
import SN from "../Image/SN.webp";
import Techclub from "../Image/Techclub.webp";
import Cyfle from "../Image/Cyfle.webp";
import LPU from "../Image/LPU.jpg";
import MMM from "../Image/MMM.jpg";
import VIT from "../Image/VIT.jpg";
import BITS from "../Image/BITM.jpg";
import IITD from "../Image/IITD.jpg";
import IPEC from "../Image/IPEC.jpg";
import Jamia from "../Image/Jamia.jpg";
import CU_Panjab from "../Image/CU_Panjab.png";
import SRM from "../Image/SRM.png";
import NITS from "../Image/NIT_Srinagar.jpeg";
import Galgotias from "../Image/Galgotias.jpg";
import CU from "../Image/CU.jpg";
import Sharda from "../Image/Sharda.jpg";
import MIT from "../Image/MIT.jpg";
import Amity from "../Image/Amity.jpg";
import Thap from "../Image/Thap.jpg";
import BHU from "../Image/BHU.jpg";
import Graphic from "../Image/Graphic.jpg";

const row1Images = [
  { src: vnit, alt: "VNIT" },
  { src: webd, alt: "Webd Logo" },
  { src: NIMBUS, alt: "NIMBUS NIT Hamirpur" },
  { src: DU, alt: "DU Delhi" },
  { src: MMM, alt: "MMM " },
  { src: VIT, alt: "VIT Vellore " },
  { src: IITD, alt: "IIT Delhi " },
  { src: Jamia, alt: "Jamia Millia Islamia " },
  { src: IPEC, alt: "Indraprastha college" },
  { src: Galgotias, alt: "Galgotias college" },
  { src: CU, alt: "CU" },
  { src: Amity, alt: "Amity" },
  { src: Thap, alt: "Thaper university" },
  
];

const row2Images = [
  { src: SN, alt: "Snosft_tech" },
  { src: Techclub, alt: "NIT Srinagar" },
  { src: Cyfle, alt: "Deshbandhu College" },
  { src: Techclub, alt: "NIT Srinagar" },
  { src: LPU, alt: "LPU College" },
  { src: BITS, alt: "BITS Mesra" },
  { src: CU_Panjab, alt: "Central University Panjab" },
  { src: SRM, alt: "SRM College" },
  { src: NITS, alt: "NIT Srinagar" },
  { src: Sharda, alt: "Sharda University" },
  { src: MIT, alt: "MIT Pune" },
  { src: BHU, alt: "BHU" },
  { src: Graphic, alt: "Graphic Era" }, 
];
function Collabration() {
  return (
    <div>
      {/* ------------------ Mobile View ------------------ */}
      <div className="pt-5 d-md-none d-sm-block">
        <div className="container text-center px-2 mobile_collabration_img">
          <h2>Collaboration That Drives Career Growth</h2>
          <p className="pt-2">
            At InternsElite, we believe in the power of collaboration. Our partnerships with skilled business partners foster innovation, create valuable career opportunities, and support long-term growth.
          </p>
        </div>
        <Zoom>
          <AppContainer>
            <Wrapper>
              {/* Row 1 */}
              <MarqueeMobile>
                <MarqueeGroupMobile>
                  {row1Images.map((el, i) => (
                    <ImageGroup key={i}>
                      <Image src={el.src} alt={el.alt} />
                    </ImageGroup>
                  ))}
                </MarqueeGroupMobile>
                <MarqueeGroupMobile>
                  {row1Images.map((el, i) => (
                    <ImageGroup key={i}>
                      <Image src={el.src} alt={el.alt} />
                    </ImageGroup>
                  ))}
                </MarqueeGroupMobile>
              </MarqueeMobile>

              {/* Row 2 */}
              <MarqueeMobile>
                <MarqueeGroupReverseMobile>
                  {row2Images.map((el, i) => (
                    <ImageGroup key={i}>
                      <Image src={el.src} alt={el.alt} />
                    </ImageGroup>
                  ))}
                </MarqueeGroupReverseMobile>
                <MarqueeGroupReverseMobile>
                  {row2Images.map((el, i) => (
                    <ImageGroup key={i}>
                      <Image src={el.src} alt={el.alt} />
                    </ImageGroup>
                  ))}
                </MarqueeGroupReverseMobile>
              </MarqueeMobile>
            </Wrapper>
          </AppContainer>
        </Zoom>
      </div>

      {/* ------------------ Desktop View ------------------ */}
      <div className="pt-5 d-md-block d-none">
        <div className="container text-center ">
          <h2 className="display-5  ">
            Collaboration That Drives Career Growth
          </h2>
          <p className="mt-3">
            At InternsElite, we believe in the power of collaboration. Our partnerships with skilled business partners foster innovation, create valuable career opportunities, and support long-term growth.
          </p>
        </div>
        <Zoom>
          <AppContainer>
            <Wrapper>
              {/* Row 1 */}
              <Marquee>
                <MarqueeGroup>
                  {row1Images.map((el, i) => (
                    <ImageGroup key={i}>
                      <Image src={el.src} alt={el.alt} />
                    </ImageGroup>
                  ))}
                </MarqueeGroup>
                <MarqueeGroup>
                  {row1Images.map((el, i) => (
                    <ImageGroup key={i}>
                      <Image src={el.src} alt={el.alt} />
                    </ImageGroup>
                  ))}
                </MarqueeGroup>
              </Marquee>

              {/* Row 2 */}
              <Marquee>
                <MarqueeGroupReverse>
                  {row2Images.map((el, i) => (
                    <ImageGroup key={i}>
                      <Image src={el.src} alt={el.alt} />
                    </ImageGroup>
                  ))}
                </MarqueeGroupReverse>
                <MarqueeGroupReverse>
                  {row2Images.map((el, i) => (
                    <ImageGroup key={i}>
                      <Image src={el.src} alt={el.alt} />
                    </ImageGroup>
                  ))}
                </MarqueeGroupReverse>
              </Marquee>
            </Wrapper>
          </AppContainer>
        </Zoom>
      </div>
    </div>
  );
}

export default Collabration;

// ------------------ Styled Components ------------------
const AppContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
`;

const Marquee = styled.div`
  display: flex;
  width: 80%;
  overflow: hidden;
  user-select: none;
  mask-image: linear-gradient(
    to right,
    hsl(0 0% 0% / 0),
    hsl(0 0% 0% / 1) 10%,
    hsl(0 0% 0% / 1) 90%,
    hsl(0 0% 0% / 0)
  );
`;

const scrollX = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
`;

// const common = css`
//   flex-shrink: 0;
//   display: flex;
//   align-items: center;
//   justify-content: space-around;
//   white-space: nowrap;
//   width: 100%;
//   animation: ${scrollX} 30s linear infinite;
// `;
const common = css`
  display: flex;
  align-items: center;
  gap: 20px;             
  flex-shrink: 0;        
  white-space: nowrap;
  animation: ${scrollX} 30s linear infinite;
`;

const MarqueeGroup = styled.div`
  ${common}
`;

const MarqueeGroupReverse = styled.div`
  ${common}
  animation-direction: reverse;
  animation-delay: -3s;
`;

// const ImageGroup = styled.div`
//   display: grid;
//   place-items: center;
//   width: clamp(10rem, 1rem + 40vmin, 30rem);
//   padding: calc(clamp(10rem, 1rem + 30vmin, 30rem) / 10);
// `;

// const Image = styled.img`
//   object-fit: contain;
//   width: 100%;
//   height: 100%;
//   border-radius: 0.5rem;
//   aspect-ratio: 16/9;
//   padding: 5px 20px;
//   box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
// `;
const ImageGroup = styled.div`
  display: grid;
  place-items: center; 
  width: 180px;    
  height: 120px;   
  padding: calc(clamp(10rem, 1rem + 30vmin, 30rem) / 10);  
  flex-shrink: 0;  
`;

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  /* border: 1px solid black; */
  border-radius: 0.5rem;
  aspect-ratio: 16/9;
  padding: 5px 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;






// ------------------ Mobile ------------------
const MarqueeMobile = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  user-select: none;
`;

const scrollXMobile = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const MarqueeGroupMobile = styled.div`
  display: flex;
  align-items: center;
  gap: 25px; 
  flex-shrink: 0;
  white-space: nowrap;
  animation: ${scrollXMobile} 20s linear infinite;
`;

const MarqueeGroupReverseMobile = styled(MarqueeGroupMobile)`
  animation-direction: reverse;
  animation-delay: -3s;
`;
